
import ChinaAddressV4Data from "../../common/ChinaAddressV4Data.json";
import XButton from 'vux/src/components/x-button/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


import {
listInvoice,
updateInvoice,
insertInvoice,
deleteInvoice,
listaddDZ,
CompanyInvInfoByCode,
CompanyCodeByKeyWord
} from "../../api/invoiceEditing.js";
export default {
directives: {
TransferDom
},
components: { Popup, Group, XAddress, XButton },
data() {
return {
kpindexID: -1, //选中 电子普通发票  增值税专用发票 收据 电子普通发票
listInvs: ["电子普通发票", "增值税专用发票", "收据", "电子普通发票"],
selectAddressData: ChinaAddressV4Data,
listInvoices: [], //发票列表
listInvoicesIndexIDItem: {}, //选中的 发票具体

idItem: {},

dzisItem: "",
zzisItem: "",
sjisItem: "",


TotalAmount: 0.0,


namellistszzs: [],
namellistslogzzs: false,
isfocusnamezzs: false,
provinceoptions: [], //省
provinceoptions1: [], //省
cityoptions: [], //市
cityoptions1: [], //市
districtoptions: [], //区
districtoptions1: [], //区

iskpindexID: false,
dialogVisiblezzs: false, //增值专用发票
dialogVisiblezzsTitle: "新增增值税专用发票",
enclosurePath3: "",
isxzzzs: false,
payAmount: 0,
zzsruleForm: {
id: null,
invoiceNature: "公司", //发票抬头
invoiceType: "", //发票类型
bankAccount: "", //银行账号
openingBank: "", //开户银行
address: "", //注册地址
taxNum: "", //纳税人识别号
title: "", //开票名称
phone: "", //电话
filePath: "", //上传开票资料
receiver: "", //收件人
deliveryPhone: "", //收件人手机号

province: "",
city: "",
district: "",
pcd: [],
detail: "" 
},
addressObjID: "",
order: {
list: [],
total: 0
},
idItem: {}, //地址



dialogVisiblesj: false, //收据
dialogVisiblesjTitle: "新增收据",

sjruleForm: {
id: null,
invoiceNature: "个人", //发票抬头
invoiceType: "", //发票类型
title: "" 
},
ordreCode: "",

isfocusnamezzs: false,
namellistslogzzs: false,
namellistszzs: []
};
},

methods: {
blurzzs() {
let that = this;
setTimeout(() => {
that.isfocusnamezzs = false;
}, 200);
},

inputnamezzs() {
this.getCompanyCodeByKeyWordzzs();
},
getCompanyCodeByKeyWordzzs() {
this.namellistslogzzs = true;
this.namellistszzs = [];
console.log("this.zzsruleForm", this.zzsruleForm);
if (this.zzsruleForm.title) {
CompanyCodeByKeyWord(this.zzsruleForm.title).then(res => {
if (res.code == 0) {
this.namellistszzs = res.obj;
} else {
}
this.namellistslogzzs = false;
});
} else {
this.namellistslogzzs = false;
}
},
bcsub1(){


this.$router.push({
path: '/myOrder'
})
},
namellistsModelckzzs(item) {
console.log("item", item);
this.zzsruleForm.title = item.name;
this.isxzzzs = true;

CompanyInvInfoByCode(item.code).then(res => {
if (res.code == 0) {

this.zzsruleForm.taxNum = res.obj.taxNo;


if (res.obj.address) {
this.$set(this.zzsruleForm, "address", res.obj.address);
}



if (res.obj.telephone) {
this.$set(this.zzsruleForm, "phone", res.obj.telephone);
}


if (res.obj.buyerBankAcc) {
this.$set(this.zzsruleForm, "openingBank", res.obj.buyerBankAcc);
}


if (res.obj.buyerBankNum) {
this.$set(this.zzsruleForm, "bankAccount", res.obj.buyerBankNum);
}
} else {
this.$message.error(res.msg);
}
this.isxzzzs = false;
});
},
noteThat() {
this.$router.push({
path: "/noteThat"
});
},
onShadowChange() {
this.zzsruleForm.province = this.$refs.addressArea1.nameValue.split(
" "
)[0];
this.zzsruleForm.city = this.$refs.addressArea1.nameValue.split(" ")[1];
this.zzsruleForm.district = this.$refs.addressArea1.nameValue.split(
" "
)[2];
},
subInvoiceszzs() {
console.log("this.zzsruleForm", this.zzsruleForm);

if (this.zzsruleForm.title == "") {
this.$vux.toast.show({
type: "cancel",
text: "开票名称不能为空"
});
return false;
}

if (this.zzsruleForm.taxNum == "") {
this.$vux.toast.show({
type: "cancel",
text: "纳税人识别号不能为空"
});
return false;
}

if (this.zzsruleForm.address == "") {
this.$vux.toast.show({
type: "cancel",
text: "注册地址不能为空"
});
return false;
}

if (this.zzsruleForm.phone == "") {
this.$vux.toast.show({
type: "cancel",
text: "注册电话不能为空"
});
return false;
}

if (this.zzsruleForm.openingBank == "") {
this.$vux.toast.show({
type: "cancel",
text: "开户银行不能为空"
});
return false;
}

if (this.zzsruleForm.bankAccount == "") {
this.$vux.toast.show({
type: "cancel",
text: "银行账号不能为空"
});
return false;
}

if (this.zzsruleForm.receiver == "") {
this.$vux.toast.show({
type: "cancel",
text: "收票人不能为空"
});
return false;
}

if (this.zzsruleForm.deliveryPhone == "") {
this.$vux.toast.show({
type: "cancel",
text: "手机号码不能为空"
});
return false;
}

if (this.zzsruleForm.province == "") {
this.$vux.toast.show({
type: "cancel",
text: "省不能为空"
});
return false;
}
if (this.zzsruleForm.city == "") {
this.$vux.toast.show({
type: "cancel",
text: "市不能为空"
});
return false;
}
if (this.zzsruleForm.district == "") {
this.$vux.toast.show({
type: "cancel",
text: "区不能为空"
});
return false;
}

if (this.zzsruleForm.detail == "") {
this.$vux.toast.show({
type: "cancel",
text: "详细地址不能为空"
});
return false;
}

var pam = {
bankAccount: this.zzsruleForm.bankAccount,
businessLicensePath: this.zzsruleForm.businessLicensePath,
address: this.zzsruleForm.address,
filePath: this.zzsruleForm.filePath,
id: this.zzsruleForm.id,
invoiceNature: this.zzsruleForm.invoiceNature,
invoiceType: this.listInvs[this.kpindexID],
mailbox: this.zzsruleForm.mailbox,
openingBank: this.zzsruleForm.openingBank,
phone: this.zzsruleForm.phone,
taxNum: this.zzsruleForm.taxNum,
title: this.zzsruleForm.title,
receiver: this.zzsruleForm.receiver, //收件人
deliveryPhone: this.zzsruleForm.deliveryPhone, //收件人手机
shippingAddress:
this.zzsruleForm.province +
"-" +
this.zzsruleForm.city +
"-" +
this.zzsruleForm.district +
"-" +
this.zzsruleForm.detail 
};
console.log("this.zzsruleForm.", this.zzsruleForm.pcd);
console.log("pam", pam);

if (this.zzsruleForm.id) {


updateInvoice(pam).then(res => {
if (res.code == 0) {
this.dialogVisiblezzs = false;

this.$vux.toast.show({
type: "success",
text: "编辑成功"
});

this.zzisItem = pam;
this.getlistInvoice();
} else {
this.zzisItem = "";

this.$vux.toast.show({
type: "cancel",
text: res.msg
});
}
});
} else {


console.log("新增pam", pam);

insertInvoice(pam).then(res => {
if (res.code == 0) {
this.dialogVisiblezzs = false;
this.getlistInvoice();

this.$vux.toast.show({
type: "success",
text: "添加成功"
});
this.zzisItem = "";
} else {
this.$vux.toast.show({
type: "cancel",
text: res.msg
});
}
});
}
},
subInvoicesj() {
if (this.sjruleForm.title == "") {
this.$vux.toast.show({
type: "cancel",
text: "开票名称不能为空"
});
return false;
}
var pam = {
id: this.sjruleForm.id,
invoiceNature: this.sjruleForm.invoiceNature, //发票抬头
title: this.sjruleForm.title, //开票名称
invoiceType: this.listInvs[this.kpindexID] 
};
if (this.sjruleForm.id) {


console.log("pam", pam);
updateInvoice(pam).then(res => {
if (res.code == 0) {
this.dialogVisiblesj = false;
console.log("编辑成功");
this.$vux.toast.show({
type: "success",
text: "编辑成功"
});
this.sjisItem = pam;
this.getlistInvoice();
} else {
this.$vux.toast.show({
type: "cancel",
text: res.msg
});
}
});
} else {


console.log("pam", pam);
insertInvoice(pam).then(res => {
if (res.code == 0) {
this.dialogVisiblesj = false;
this.getlistInvoice();

this.$vux.toast.show({
type: "success",
text: "添加成功"
});

this.sjisItem = "";
} else {
this.$vux.toast.show({
type: "cancel",
text: res.msg
});
}
});
}
},
isinvoiceNaturezzs(name) {
this.zzsruleForm.invoiceNature = name;
},
isinvoiceNaturesj(name) {
this.sjruleForm.invoiceNature = name;
},
getname() {
let name = "";
let isanme = "";
if ((this.kpindexID = 0)) {
} else if ((this.kpindexID = 1)) {
name = "";
} else if ((this.kpindexID = 2)) {
} else if ((this.kpindexID = 3)) {
}
return isanme + name;
},
setlistInvoicesIndexID(item) {
if (this.listInvs[this.kpindexID] == "增值税专用发票") {
if (item.receiver) {
this.listInvoicesIndexIDItem = item;
this.zzisItem = item;
} else {
this.$vux.toast.show({
type: "cancel",
text: "请完善增值专用发票的收票地址"
});

this.editzzs(item);
}
} else if (this.listInvs[this.kpindexID] == "电子普通发票") {
this.listInvoicesIndexIDItem = item;
this.dzisItem = item;
} else {
this.listInvoicesIndexIDItem = item;
this.sjisItem = item;
}
},
jump11(val) {
localStorage.setItem("invoiceIditem", JSON.stringify({}));

if (this.kpindexID == val) {
this.kpindexID = -1;
} else {
this.kpindexID = val;
}
},
jump1(val) {
if (val == 1) {
if (this.iskpindexID) {
localStorage.setItem("invoiceIditem", JSON.stringify({}));
if (this.kpindexID == val) {
this.kpindexID = -1;
} else {
this.kpindexID = val;
}
var pam = {
cartType: this.cartType,
invoiceType: this.listInvs[this.kpindexID]
? this.listInvs[this.kpindexID]
: "",
province: this.idItem.province ? this.idItem.province : ""
};

this.getlistInvoice();
}
} else {
localStorage.setItem("invoiceIditem", JSON.stringify({}));
if (this.kpindexID == val) {
this.kpindexID = -1;
} else {
this.kpindexID = val;
}
var pam = {
cartType: this.cartType,
invoiceType: this.listInvs[this.kpindexID]
? this.listInvs[this.kpindexID]
: "",
province: this.idItem.province ? this.idItem.province : ""
};

this.getlistInvoice();
}
},
add() {
console.log("kpindexID", this.kpindexID);
if (this.kpindexID == 1) {
console.log("idItem", this.idItem);

let pcd = [];

this.dialogVisiblezzs = true;
this.zzsruleForm = {
id: null,
invoiceNature: "公司", //发票抬头
invoiceType: "", //发票类型
bankAccount: "", //银行账号
openingBank: "", //开户银行
address: "", //注册地址
taxNum: "", //纳税人识别号
title: "", //开票名称
phone: "", //电话
filePath: "", //上传开票资料

province: this.idItem ? this.idItem.province : "",
city: this.idItem ? this.idItem.city : "",
district: this.idItem ? this.idItem.district : "",
detail: this.idItem ? this.idItem.detail : "",
receiver: this.idItem ? this.idItem.receiver : "",
deliveryPhone: this.idItem ? this.idItem.phone : "",
pcd: pcd
};

if (this.zzsruleForm.province) {
console.log("this.zzsruleForm.province", this.zzsruleForm.province);
pcd.push(this.getidzname(this.zzsruleForm.province));
}
if (this.zzsruleForm.city) {
console.log("this.zzsruleForm.city", this.zzsruleForm.city);

pcd.push(this.getidzname(this.zzsruleForm.city));
}
if (this.zzsruleForm.district) {
console.log("this.zzsruleForm.district", this.zzsruleForm.district);
pcd.push(this.getidzname(this.zzsruleForm.district));
}

this.zzsruleForm.pcd = pcd;
} else if (this.kpindexID == 2) {
(this.sjruleForm = {
id: null,
invoiceNature: "个人", //发票抬头
title: "", //开票名称
invoiceType: "" 
}),
(this.dialogVisiblesj = true);
} else {
console.log("wu");
}
},
getidzname(name) {
let value = "";
console.log("name", name);
if (name) {
for (let i = 0; this.selectAddressData.length; i++) {
if (name == this.selectAddressData[i].name) {
value = this.selectAddressData[i].value;
break;
}
}
} else {
value = "";
}

return value;
},
selectedInvoiceOrder() {
this.$request
.post("/order/patchInvoice", {
orderCode: this.$route.query.ordreCode
})
.then(data => {
if (data.code == 0) {
this.order.list = data.obj;
data.obj.forEach((item, index) => {
this.order.total =
(this.order.total * 1000 +
Number(item.totalAmt) * 1000 +
Number(item.expressAmt) * 1000) /
1000;
this.payAmount = this.order.total;
});
} else {
this.$vux.toast.show({
type: "cancel",
text: data.msg
});
}
})
.catch(e => {
console.log(e);
});
},

editzzs(item) {
console.log("item", item);
this.dialogVisiblezzsTitle = "编辑增值专用发票";
this.dialogVisiblezzs = true;

let pcd = [];
var province = item.shippingAddress
? item.shippingAddress.split("-")[0]
: this.idItem.province;
var city = item.shippingAddress
? item.shippingAddress.split("-")[1]
: this.idItem.city;
var district = item.shippingAddress
? item.shippingAddress.split("-")[2]
: this.idItem.district;
var detail = item.shippingAddress
? item.shippingAddress.split("-")[3]
: this.idItem.detail;
var receiver = item.receiver ? item.receiver : this.idItem.receiver;
var deliveryPhone = item.deliveryPhone
? item.deliveryPhone
: this.idItem.phone;

this.zzsruleForm = {
pcd: pcd,
id: item.id,
address: item.address,
invoiceNature: item.invoiceNature, //发票抬头
invoiceType: item.invoiceType, //发票类型
bankAccount: item.bankAccount, //银行账号
openingBank: item.openingBank, //开户银行
taxNum: item.taxNum, //纳税人识别号
title: item.title, //开票名称
phone: item.phone, //电话
filePath: item.filePath, //上传开票资料

receiver: receiver,
deliveryPhone: deliveryPhone,
province: province,
city: city,
district: district,
detail: detail 
};

if (province != "" && province != "undefined") {
pcd.push(this.getidzname(province));
}
if (city && city != "undefined") {
pcd.push(this.getidzname(city));
}
if (district && district != "undefined") {
pcd.push(this.getidzname(district));
}

this.zzsruleForm.pcd = pcd;
},
closeInvoiceBoxzzs() {

this.dialogVisiblezzs = false;
},
closeInvoiceBoxjs() {
this.dialogVisiblesj = false;
},
focusnamezzs() {
this.isfocusnamezzs = true;

this.getCompanyCodeByKeyWordzzs();
},
getlistInvoice() {
var pam = {
invoiceType: this.listInvs[this.kpindexID]
};
console.log("pam", pam);

listInvoice(pam).then(res => {
this.listInvoices = res.obj;
if (this.listInvoices.length > 0) {
if (this.listInvs[this.kpindexID] == "增值税专用发票") {
console.log("this.zzisItem", this.zzisItem);
if (this.zzisItem) {
this.listInvoicesIndexIDItem = this.zzisItem;
} else {
if (this.listInvoices[0].receiver) {
this.listInvoicesIndexIDItem = this.listInvoices[0];
} else {
this.listInvoicesIndexIDItem = "";
}
}
} else if (this.listInvs[this.kpindexID] == "电子普通发票") {
if (this.dzisItem) {
this.listInvoicesIndexIDItem = this.dzisItem;
} else {
this.listInvoicesIndexIDItem = this.listInvoices[0];
}
} else {
if (this.sjisItem) {
this.listInvoicesIndexIDItem = this.sjisItem;
} else {
this.listInvoicesIndexIDItem = this.listInvoices[0];
}
}
} else {
this.listInvoicesIndexIDItem = "";
}
});
},


isdialogVisiblezzs() {
console.log("idItem", this.idItem);

this.dialogVisiblezzsTitle = "新增增值税专用发票";
(this.zzsruleForm = {
id: null,
invoiceNature: "公司", //发票抬头
invoiceType: "", //发票类型
bankAccount: "", //银行账号
openingBank: "", //开户银行
address: "", //注册地址
taxNum: "", //纳税人识别号
title: "", //开票名称
phone: "", //电话
filePath: "", //上传开票资料

province: this.idItem ? this.idItem.province : "",
city: this.idItem ? this.idItem.city : "",
district: this.idItem ? this.idItem.district : "",
detail: this.idItem ? this.idItem.detail : "",
receiver: this.idItem ? this.idItem.receiver : "",
deliveryPhone: this.idItem ? this.idItem.phone : ""
}),
(this.dialogVisiblezzs = true);
},


editsj(item) {
this.dialogVisiblesjTitle = "编辑收据";
this.dialogVisiblesj = true;

this.sjruleForm = {
id: item.id,
invoiceNature: item.invoiceNature, //发票抬头
invoiceType: item.invoiceType, //发票类型
title: item.title 
};
console.log(this.sjruleForm);
},
delInvoice(item) {
var pam = {
id: item.id
};
deleteInvoice(pam).then(res => {
if (res.code == 0) {
this.$vux.toast.show({
type: "success",
text: "删除成功"
});

if (this.listInvs[this.kpindexID] == "增值税专用发票") {
if (this.zzisItem) {
if (this.zzisItem.id == item.id) {
this.zzisItem = "";
this.listInvoicesIndexIDItem = "";
}
}
} else if (this.listInvs[this.kpindexID] == "电子普通发票") {
if (this.dzisItem) {
console.log("this.dzisItem", this.dzisItem);
if (this.dzisItem.id == item.id) {
console.log("xiangdeng ", this.dzisItem);
this.dzisItem = "";
this.listInvoicesIndexIDItem = "";
} else {
console.log("bd ", this.dzisItem);
}
console.log(
"listInvoicesIndexIDItem ",
this.listInvoicesIndexIDItem
);
}
} else {
if (this.sjisItem) {
if (this.sjisItem.id == item.id) {
this.sjisItem = "";
this.listInvoicesIndexIDItem = "";
}
}
}

this.getlistInvoice();
} else {
this.$message.error(res.msg);
}
});
},
bcsub2(){
this.$router.push({  path: '/requestInvoice' })
},
bcsub() {
console.log("不选", this.kpindexID);
let invoiceIditem = {};
if (this.kpindexID == 1) {
invoiceIditem = this.listInvoicesIndexIDItem;
} else if (this.kpindexID == 2) {
invoiceIditem = this.listInvoicesIndexIDItem;
} else {
invoiceIditem = {};
console.log("不选");
}



var orderIdList = "";

for (var i = 0; i < this.order.list.length; i++) {
orderIdList = orderIdList + this.order.list[i].id + ",";
}

orderIdList = orderIdList.substr(0, orderIdList.length - 1);

var pam1 = {

orderId: orderIdList

};

console.log('pam1',pam1);






let pam2={}
if (this.kpindexID != -1) {
pam2 = {
invoiceId: this.listInvoicesIndexIDItem.id
};
} else {
pam2 = {
invoiceId: ""
};
}
var pam = Object.assign(pam1, pam2);
console.log('pam1',pam1);
console.log('pam',pam);
this.$request.post("/invoice/patchInvoice", pam).then(data => {
if(data.code == 0){


this.$vux.toast.show({
type: 'success',
text: '已补开发票！'
})
let that=this
setTimeout(function() {
that.$router.push({  path: '/invoiceInfo' })
}, 1000);

}else{

}
});
},

getlistaddDZ(val1) {
listaddDZ({}).then(res => {
if (res.code == 0) {
for (let i = 0; i < res.obj.length; i++) {
if (res.obj[i].boolDefault=='1') {
this.idItem = res.obj[i];
break;
}

}
}

console.log(' this.idItem', this.idItem);
});
}
},
mounted() {

this.selectedInvoiceOrder();
localStorage.setItem("invoiceIditem", JSON.stringify({}));





this.getlistaddDZ();


console.log(this.payAmount);
},
created() {},
props: {},
watch: {
payAmount: function() {


if (this.payAmount >= 100) {
this.iskpindexID = true; 
} else {
this.payAmount = false;
this.iskpindexID = false; 
this.kpindexID = -1;
}
}
}
};



// WEBPACK FOOTER //
// ./src/views/supplementalInvoice/supplementalInvoice.vue